export default __webpack_public_path__ + "ch-worlds.icon-b38a10c8f458f2f63fb4fdbd7a7427c2.png";